import DataMapper from './DataMapper'
import InvestigatorActivityDetail from '../../models/InvestigatorActivityDetail'
import InvestigatorActivityDetailRM from '../responsemodel/InvestigatorActivityDetailRM'

class InvestigatorActivityDetailDataMapper extends DataMapper<InvestigatorActivityDetailRM, InvestigatorActivityDetail> {
    map = (rm: InvestigatorActivityDetailRM) => new InvestigatorActivityDetail(rm.checkDate, rm.investigator_name, rm.punchInTime, rm.punchOutTime, rm.totalDistance, rm.details)
}
export default InvestigatorActivityDetailDataMapper
